const companyStatusOpitons = [
  { value: "active", label: "Aktywne" },
  { value: "withdrawn", label: "Wycofane" },
  { value: "hidden", label: "Ukryte" },
];

export default companyStatusOpitons;
